import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface StepConfirmationModalProps {
  currentStep: number;
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onContinue: () => void;
}

const StepConfirmationModal: React.FC<StepConfirmationModalProps> = ({
  currentStep,
  show,
  onClose,
  onSubmit,
  onContinue,
}) => {
  const getContent = () => {
    switch (currentStep) {
      case 1:
        return {
          message: 'Are you ready to submit your form now, or would you like to continue to the Customer Specification details?',
          buttons: (
            <>
              <Button className="blueButtonOutline" sx={{ height: 50, width: 120, fontWeight: 600 }} onClick={onContinue}>
                CONTINUE
              </Button>
              <Button className="blueButtonOutline" sx={{ height: 50, width: 120, fontWeight: 600 }} onClick={onSubmit}>
                SUBMIT
              </Button>
            </>
          ),
        };
      case 2:
        return {
          message: 'The next step is to submit your request. Are you ready to submit?',
          buttons: (
            <>
              <Button className="blueButtonOutline" sx={{ height: 50, width: 120, fontWeight: 600 }} onClick={onClose}>
                CANCEL
              </Button>
              <Button className="blueButtonOutline" sx={{ height: 50, width: 120, fontWeight: 600 }} onClick={onSubmit}>
                SUBMIT
              </Button>
            </>
          ),
        };
      default:
        return { message: '', buttons: null };
    }
  };

  const { message, buttons } = getContent();

  return (
    <Dialog
      open={show}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          textAlign: 'center',
          minWidth: 400,
        },
      }}
    >
      <DialogContent>
        <DialogContentText
          sx={{ fontSize: '21px', fontWeight: 600, color: '#494440', lineHeight: '1.2' }}
          fontFamily={'"Montserrat", Verdana, sans-serif'}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        {buttons}
      </DialogActions>
    </Dialog>
  );
};

export default StepConfirmationModal;